import { observer } from 'mobx-react-lite'
import { Icon, Status, Switch, Tooltip, Typography } from 'shared/ui'
import { SelectField } from 'shared/ui/Select/SelectField/SelectField'
import { CreateNewAIAgent } from 'entities/Chatbot/actions/CreateNewAIAgent/CreateNewAIAgent'
import { type AiRepliesStore } from '../store/aiRepliesStore'
import styles from './styles.module.scss'

type IAiRepliesProps = {
  store: AiRepliesStore
}

export const AiReplies = observer(({ store }: IAiRepliesProps) => {
  const {
    error,
    isAiRepliesActive,
    setAiRepliesState,
    agentItem,
    dropDownItems,
    setAiItem,
    onChangeOpen,
    onLoadMore,
    loading,
    loadingMore,
    search,
    setSearch,
    disabled,
    disabledReason,
  } = store

  const content = (
    <div className={styles.wrap}>
      <Icon icon={'stars'} color='var(--purple-70)' />
      <div className={styles.center}>
        <div className={styles.info}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Typography ariaLabel={'AiReplies'} variant={'body-md-semibold'}>
              Handle replies with AI
            </Typography>
            <Status
              title={'New'}
              intent={'purple'}
              emphasis={'high'}
              size={'label'}
              className={styles.listItemContentNew}
            />
          </div>
          <Typography
            ariaLabel={'AiRepliesDesc'}
            variant={'body-md-regular'}
            color={'var(--content-primary-tertiary)'}
          >
            Let an AI Agent respond to your contacts&#39; replies
          </Typography>
        </div>
        {isAiRepliesActive && (
          <div className={styles.select}>
            <SelectField
              selectProps={{
                variant: 'stroke',
                textFieldPlaceholderProps: {
                  className: styles.textFieldPlaceholder,
                },
              }}
              error={error}
              item={agentItem}
              items={dropDownItems}
              search={search}
              loading={loading}
              onSearch={setSearch}
              onLoadMore={onLoadMore}
              setValue={setAiItem}
              dropdownProps={{
                maxHeight: loadingMore ? 122 : 168,
                placement: 'bottom-end',
                onChangeOpen,
                propsDropdownList: {
                  notFoundText: (
                    <CreateNewAIAgent style={{ marginLeft: '4px', marginRight: '4px' }} />
                  ),
                  searchWrapClassName: styles.searchInput,
                  isTopReverse: true,
                  loadingMore,
                },
                bottomActions: (onCloseMenu) => <CreateNewAIAgent onCloseMenu={onCloseMenu} />,
              }}
            />
          </div>
        )}
      </div>
      <div>
        <Switch value={isAiRepliesActive} onChange={setAiRepliesState} disabled={disabled} />
      </div>
    </div>
  )

  return disabled && disabledReason ? (
    <Tooltip fullWidth placement='top' label={disabledReason}>
      {content}
    </Tooltip>
  ) : (
    content
  )
})
